<template>
  <div>
    <v-card-title>BESTÄLLNING</v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col class="subtitle">Avser</v-col>
        <v-col>
          <div>Maskinkort lärling</div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="subtitle">KORTINNEHAVARE</v-col>
        <v-col>
          <div v-if="selectedOrder.print && selectedOrder.print.person">
            <router-link :to="'/people/' + selectedOrder.print.person.id">
              {{ selectedOrder.print.person | fullName }}
              {{ selectedOrder.print.person.personalNumber | formatSecretPnr }}</router-link
            >
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="subtitle">SPECIFICERING</v-col>
        <v-col>
          <div v-if="machines">
            {{ machines }}
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="subtitle"> Kostnadsställe </v-col>
        <v-col class="mr-11">
          <div class="d-flex justify-content-between">
            <div v-if="!showEditcostCenter" class="mr-2">
              <v-icon small @click="showEditcostCenter = true">$sl-edit</v-icon>
            </div>
            <div v-if="!showEditcostCenter">
              {{ selectedOrder.costCenter ? selectedOrder.costCenter : 'Ej angivet.' }}
            </div>
            <div v-else>
              <div class="d-flex justify-content-between">
                <div>
                  <v-text-field dense v-model="selectedOrder.costCenter" outlined />
                </div>

                <div class="ml-2 mt-2">
                  <v-icon
                    @click="
                      $emit('constCenter', selectedOrder.costCenter)
                      showEditcostCenter = false
                    "
                    >$sl-check</v-icon
                  >
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'OrderInfo',
  props: {
    machines: {
      type: String,
      default: ''
    },
    selectedOrder: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showEditcostCenter: false
    }
  },
  created() {
    //console.log('this.machines :>> ', this.machines)
  }
}
</script>

<style lang="scss" scoped>
</style>